import { render, staticRenderFns } from "./card-key-features.vue?vue&type=template&id=146db9be&scoped=true&"
import script from "./card-key-features.vue?vue&type=script&lang=js&"
export * from "./card-key-features.vue?vue&type=script&lang=js&"
import style0 from "./card-key-features.vue?vue&type=style&index=0&id=146db9be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146db9be",
  null
  
)

export default component.exports